import { render } from "./BroodmareListView.vue?vue&type=template&id=0af62e5e&scoped=true"
import script from "./BroodmareListView.vue?vue&type=script&lang=js"
export * from "./BroodmareListView.vue?vue&type=script&lang=js"

import "./BroodmareListView.vue?vue&type=style&index=0&id=0af62e5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af62e5e"]])

export default __exports__